import { useParams, Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { SERVICES } from './services';
import './App.css';

function ServiceDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const service = SERVICES.find(s => s.slug === slug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [slug]);

  const handleBackHome = () => {
    navigate('/');
    setTimeout(() => {
      document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
    }, 120);
  };

  if (!service) {
    return (
      <div className="tc-notfound">
        <h2>Service not found</h2>
        <Link to="/" className="tc-detail__back">← Back to Home</Link>
      </div>
    );
  }

  return (
    <div className="tc-detail-page">

      {/* ── DETAIL NAVBAR ── */}
      <nav className="tc-navbar">
        <div className="tc-navbar__inner">
          <Link to="/" className="tc-navbar__brand" style={{ textDecoration: 'none' }}>
            <span className="tc-navbar__logo"><img src={`${process.env.PUBLIC_URL}/logo24hrs.png`} alt="24Hrs Cabs Logo" /></span>
          </Link>
          <div className="tc-detail__nav-actions">
            <a href="tel:02038393300" className="tc-detail__call">
              <i className="fas fa-phone-alt"></i> 020 3839 3300
            </a>
            <button onClick={handleBackHome} className="tc-btn tc-btn--outline-dark tc-detail__home-btn">
              <i className="fas fa-home"></i> Back to Home
            </button>
          </div>
        </div>
      </nav>

      {/* ── HERO IMAGE ── */}
      <div className="tc-detail__hero">
        <img
          src={`${process.env.PUBLIC_URL}${service.img}`}
          alt={service.title}
        />
        <div className="tc-detail__hero-overlay">
          <div className="tc-detail__hero-content">
            <span className="tc-detail__hero-icon"><i className={service.icon}></i></span>
            <h1 className="tc-detail__hero-title">{service.title}</h1>
          </div>
        </div>
      </div>

      {/* ── CONTENT ── */}
      <div className="tc-container tc-detail__body">

        {/* Description */}
        <div className="tc-detail__desc">
          {service.fullDesc.map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>

        {/* Features */}
        <div className="tc-detail__features-section">
          <h2 className="tc-detail__features-title">
            <i className={service.icon}></i> Key Features
          </h2>
          <div className="tc-detail__features">
            {service.features.map((f, i) => (
              <div className="tc-detail__feature" key={i}>
                <i className="fas fa-check-circle"></i>
                <span>{f}</span>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="tc-detail__cta">
          <a
            href="https://booktaxinow.co.uk/"
            target="_blank"
            rel="noreferrer"
            className="tc-detail__book-btn"
          >
            <i className="fas fa-car"></i> Book Now
          </a>
          <a href="tel:02038393300" className="tc-detail__call-btn">
            <i className="fas fa-phone-alt"></i> 020 3839 3300
          </a>
          <a
            href="https://wa.me/447365874733"
            target="_blank"
            rel="noreferrer"
            className="tc-detail__whatsapp-btn"
          >
            <i className="fab fa-whatsapp"></i> WhatsApp Us
          </a>
        </div>

      </div>

      {/* ── FOOTER STRIP ── */}
      <div className="tc-detail__footer-strip">
        <div className="tc-container">
          <span><i className="fas fa-map-marker-alt"></i> London, United Kingdom</span>
          <span><i className="fas fa-envelope"></i> info@taxicabs-24hrs.co.uk</span>
          <span><i className="fas fa-clock"></i> Open 24 Hours / 7 Days</span>
        </div>
      </div>

    </div>
  );
}

export default ServiceDetail;
